import React from 'react';
import { Box } from '@mui/material';
import { DirigeantPMWidget, DirigeantPMWidgetType } from '../../molecules';

export type DirigeantPMListProps = {
    items?: Array<DirigeantPMWidgetType>;
};

export const DirigeantPMList: React.FunctionComponent<DirigeantPMListProps> = function (
    props: DirigeantPMListProps,
) {
    const { items } = props;
    return (
        <Box>
            {items
                ? items.map((itemProps: DirigeantPMWidgetType, index) => (
                      <DirigeantPMWidget
                          key={`dirigeantPM-${itemProps.dirigeantPM.entreprise.denomination}-${itemProps.dirigeantPM.entreprise.siren}}`}
                          {...itemProps}
                          index={index}
                      />
                  ))
                : null}
        </Box>
    );
};
